<template>
	<div class="custom-canvas">
		<canvas ref="custom-canvas" />
		<slot />
	</div>
</template>

<script>
import Logger from '@/helpers/logging/Logger.js'

export default {
	name: 'CustomCanvas',

	provide() {
		return {
			register: this.register,
			update: this.update,
		}
	},

	props: {
		width: {
			type: Number,
			default: 200,
		},
		height: {
			type: Number,
			default: 100,
		},
		debug: { type: Boolean, default: false },
	},

	data() {
		return {
			layers: [],
		}
	},

	computed: {
		orderedLayers() {
			const layers = Array.from(this.layers)
			return layers.sort((layerA, layerB) => {
				return (layerA?.order ?? 0) - (layerB?.order ?? 0)
			})
		},
	},

	watch: {
		width() {
			const canvasElement = this.$refs['custom-canvas']
			canvasElement.width = this.width
			this.draw()
		},
		height() {
			const canvasElement = this.$refs['custom-canvas']
			canvasElement.height = this.height
			this.draw()
		},
		layers: {
			deep: true,
			handler() {
				this.draw()
			},
		},
	},

	mounted() {
		const canvasElement = this.$refs['custom-canvas']
		canvasElement.width = this.width
		canvasElement.height = this.height
	},

	methods: {
		register(val) {
			if (this.layers.find((element) => element.id === val.id)) { return }
			this.layers.push(val)
			if (this.debug) {
				Logger.debug(`registered as layer ${ this.layers.length }:`, val.type)
			}
			this.draw()
		},

		update(val) {
			if (this.debug) {
				Logger.debug('update', val)
			}
			const elementIndex = this.layers.findIndex((element) => element.id === val.id)
			this.layers[elementIndex] = val
			this.draw()
		},

		draw() {
			if (this.debug) {
				Logger.log('draw')
			}
			const canvasElement = this.$refs['custom-canvas']
			const ctx = canvasElement.getContext('2d')
			ctx.clearRect(0, 0, this.width, this.height)

			this.orderedLayers.forEach((element) => {
				element.draw(ctx)
			})
		},
	},
}
</script>
